import Modal from '../Modal'
import LoadingSpinner from '../LoadingSpinner'

interface Props {
    onClose: () => void
}

export default function HelixSearchDataLoadingModal({ onClose }: Props) {
    return (
        <Modal
            onClose={onClose}
            title="Loading search results..."
            size="medium"
            allowUserToClose={false}
        >
            <div className="mt-4">
                <LoadingSpinner />
            </div>
        </Modal>
    )
}
